import moment from 'moment';
import { useEffect, useState } from 'react';
import { Edit, X } from 'react-feather';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import { ExpirationPayment } from '../interfaces/expiration-payment';
import { Remittance } from '../interfaces/remittance';
import { api } from '../services/api';
import { expirationPaymentStatusToString, formatNumber } from '../services/helpers';
import myToastr from '../services/toastr';
import ExpirationPaymentModal from './expiration-payment-modal';

interface Props {
  closeModal: () => void;
  onExpirationPaymentUpdate?: () => void;
  remittanceId?: number | null;
  show: boolean;
}

const RemittanceModal = ({ closeModal, onExpirationPaymentUpdate, remittanceId, show }: Props) => {
  const [remittance, setRemittance] = useState<Remittance | null>(null);
  const [showExpirationPaymentModal, setShowExpirationPaymentModal] = useState(false);
  const [selectedExpirationPayment, setSelectedExpirationPayment] = useState<ExpirationPayment | null>(null);

  useEffect(() => {
    if (remittanceId && show) {
      getRemittance();
    } else {
      setRemittance(null);
    }
  }, [show, remittanceId]);

  const getRemittance = async () => {
    try {
      const data = await api.getRemittance(remittanceId!);
      setRemittance(data);
    } catch (e: any) {
      myToastr.error(e.response.data.message);
    }
  };

  const onExpirationPaymentModalClose = async (result: boolean) => {
    if (result) {
      await getRemittance();
      onExpirationPaymentUpdate?.();
    }
    setShowExpirationPaymentModal(false);
    setSelectedExpirationPayment(null);
  };

  if (!remittance) {
    return null;
  }

  return (
    <>
      <Modal className="vercomi-modal my-form expiration-modal" isOpen={show} onRequestClose={() => closeModal()} shouldCloseOnOverlayClick={false}>
        <div className="content">
          <div className="d-flex justify-content-between mb-3">
            <div className="title">Remesa {remittance.internalId}</div>
            <button type="button" className="close-button-modal" onClick={() => closeModal()} title="Cerrar">
              <X size={16} />
            </button>
          </div>
          <div className="table-payments">
            <table className="my-table">
              <thead>
                <tr>
                  <th>Cliente</th>
                  <th>Factura</th>
                  <th>Referencia pago</th>
                  <th>Fecha pago</th>
                  <th>Cantidad</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {remittance.expirationPayments.map((ep) => {
                  const clientName = ep.expiration.invoice?.customer?.billingBusinessName ?? ep.expiration.invoice?.organizationClient?.relatedOrganization?.businessName;
                  return (
                    <tr key={ep.id}>
                      <td>{clientName}</td>
                      <td>
                        {ep.expiration.invoice && (
                          <Link style={{ textDecoration: 'none' }} to={`/factura/${ep.expiration.invoice.id}`}>
                            {ep.expiration.invoice.internalId}
                          </Link>
                        )}
                        {ep.expiration.deliveryNote && (
                          <Link style={{ textDecoration: 'none' }} to={`/compra/${ep.expiration.deliveryNote.id}`}>
                            {ep.expiration.deliveryNote.internalId}
                          </Link>
                        )}
                      </td>
                      <td>{ep.internalNumber}</td>
                      <td>{moment(ep.expirationDate).format('DD/MM/YYYY')}</td>
                      <td>{formatNumber(ep.amount)} €</td>
                      <td>{expirationPaymentStatusToString(ep.status)}</td>
                      <td>
                        <div title="Actualizar estado">
                          <Edit
                            color="#222E3D"
                            onClick={() => {
                              setSelectedExpirationPayment(ep);
                              setShowExpirationPaymentModal(true);
                            }}
                            size={16}
                            type="button"
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <button className="save-button" type="button" onClick={() => closeModal()}>
          Cerrar
        </button>
      </Modal>
      <ExpirationPaymentModal closeModal={onExpirationPaymentModalClose} open={showExpirationPaymentModal} expirationPayment={selectedExpirationPayment} />
    </>
  );
};

export default RemittanceModal;
